import { styled } from '@mui/material';

export const StyledLabel = styled('span', { shouldForwardProp: prop => prop !== 'isSelected' })<{
    isSelected?: boolean;
}>(({ theme, isSelected }) => ({
    ...theme.typography.body1,
    fontWeight: 600,
    color: theme.palette.grey[800],

    ...(isSelected && {
        color: undefined,
    }),
}));
